import React, { useState, useEffect } from "react";
import {
	Table,
	Form,
	Row,
	Col,
	App,
	Card,
	Button,
	Select,
	Dropdown,
	Modal,
	Input,
	Empty,
	DatePicker,
	Checkbox,
	Collapse,
	Tooltip,
} from "antd";
import {
	TeamOutlined,
	EyeOutlined,
	CommentOutlined,
	MenuOutlined,
	UnorderedListOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Excel } from "antd-table-saveas-excel";
import commentService from "../../services/comment";
import formService from "../../services/form";
import TaskDetailsComponent from "../../components/taskDetails";
import DefaultLayout from "../../components/layout/DefaultLayout";
import Header from "../../components/header";
import { useMediaQuery } from "react-responsive";
import locationService from "./../../services/location";
import UserComponent from "./../../components/user";
import FormListComponent from "./../../components/serviceDeskFormList";
import taskService from "../../services/tasks";
import qaService from "../../services/qualityAssurance";
import departmentService from "../../services/department";
import styles from "./index.css";
import moment from "moment";
const { Panel } = Collapse;
const ServiceDesk = () => {
	const { notification } = App.useApp();
	const dateFormat = "DD-MM-YYYY";
	const [searchForm2] = Form.useForm();
	const [searchForm] = Form.useForm();
	const [form] = Form.useForm();
	const [selectedForm, setSelectedForm] = useState(2); // Set initial state to 2
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [isExporting, setIsExporting] = useState(false);
	const [currentPage, setCurrentPage] = useState(1);
	const [totalDataCount, setTotalDataCount] = useState(0);
	const [itemsPerPage, setItemsPerPage] = useState(100);
	const [page, setPage] = useState(1);
	const [isUATModalVisible, setIsUATModalVisible] = useState(false);
	const [isTaskModalVisible, setIsTaskModalVisible] = useState(false);
	const [isSendQaModalVisible, setIsSendQaModalVisible] = useState(false);
	const [currentKey, setCurrentKey] = useState(null);
	const [currentLocation, setCurrentLocation] = useState(null);
	// const [formVisible, setFormVisible] = useState(false);
	const [taskId, setTaskId] = useState(false);
	const [edit, setEdit] = useState(true);
	const [formData, setFormData] = useState(null);
	const [locations, setLocations] = useState([]);
	const [taskStatus, setTaskStatus] = useState([]);
	const [departments, setDepartments] = useState(null);
	const [sortBy, setSortBy] = useState(null);
	const [sortOrder, setSortOrder] = useState(null);
	const [selectedDate, setSelectedDate] = useState(null);
	const [selectedStartDate, setSelectedStartDate] = useState(null);
	const [selectedEndDate, setSelectedEndDate] = useState(null);
	const [visible, setVisible] = useState(false);

	const [searchFilters, setSearchFilters] = useState({});
	const { currentUser } = useSelector((state) => state.user);

	// User-scoped localStorage key with 24-hour TTL
	const sdLocalKey = currentUser?.user_id ? `sdLocal_${currentUser.user_id}` : null;
	const SD_TTL_MS = 24 * 60 * 60 * 1000;

	const getDepartments = async () => {
		const response = await departmentService.getAllDepartments();
		setDepartments(response);
	};

	const getTaskStatus = async () => {
		const response = await taskService.getTaskStatus();
		setTaskStatus(response.data);
	};

	// On component mount, load saved filters
	// useEffect(() => {
	// 	const savedFilters = localStorage.getItem("userAccessFilters");
	// 	if (savedFilters) {
	// 		const parsedFilters = JSON.parse(savedFilters);

	// 		// Set form values
	// 		searchForm.setFieldsValue(parsedFilters);

	// 		// Set date pickers if using separate state
	// 		if (parsedFilters.task_approval_at) setSelectedDate(parsedFilters.task_approval_at);
	// 		if (parsedFilters.start_at) setSelectedStartDate(parsedFilters.start_at);
	// 		if (parsedFilters.due_at) setSelectedEndDate(parsedFilters.due_at);

	// 		// Perform search automatically with dates directly from savedFilters
	// 		const searchValues = {
	// 			...parsedFilters,
	// 			task_approval_at: parsedFilters.task_approval_at || null,
	// 			start_at: parsedFilters.start_at || null,
	// 			due_at: parsedFilters.due_at || null,
	// 		};

	// 		onSearch(searchValues);
	// 	}
	// }, [localStorage.getItem("userAccessFilters"), formData]);

	const saveStateToLocal = (filters, page, pageSize, sort) => {
		if (!sdLocalKey) return;
		try {
			localStorage.setItem(
				sdLocalKey,
				JSON.stringify({ filters, page, pageSize, sort, savedAt: Date.now() })
			);
		} catch (e) {
			console.warn("Could not save SD state:", e);
		}
	};

	// Restore saved state on mount
	useEffect(() => {
		if (!sdLocalKey) return;
		try {
			const saved = localStorage.getItem(sdLocalKey);
			console.log("Restoring SD state from localStorage:", saved);
			if (saved) {
				const parsed = JSON.parse(saved);
				if (parsed.savedAt && Date.now() - parsed.savedAt > SD_TTL_MS) {
					localStorage.removeItem(sdLocalKey);
					return;
				}
				const { filters = {}, page = 1, pageSize = 15, sort = { field: "", order: "" } } = parsed;
				
				// Handle specific task_status parsing
				if (filters.task_status === 0 || filters.task_status === "0") {
					filters.task_status = ["empty"]; // show No Status
				} else if (typeof filters.task_status === "string") {
					filters.task_status = filters.task_status
						.split(",")
						.map(Number);
				} else {
					delete filters.task_status;
				}

				// Set date pickers state
				if (filters.task_approval_at) setSelectedDate(filters.task_approval_at);
				if (filters.start_at) setSelectedStartDate(filters.start_at);
				if (filters.due_at) setSelectedEndDate(filters.due_at);

				searchForm.setFieldsValue(filters);
				setCurrentPage(page);
				setItemsPerPage(pageSize);
				setSortBy(sort.field || "");
				setSortOrder(sort.order || "");

				// Check if any real filter values were saved
				const hasFilters = Object.values(filters).some(
					(v) => v !== undefined && v !== "" && v !== null && (!Array.isArray(v) || v.length > 0)
				);

				if (hasFilters) {
					setSearchFilters(filters);
					// Re-run the search with the saved filters and pagination
					const searchValues = { ...filters, form_id: selectedForm };
					formService
						.search(selectedForm, { ...searchValues, page, per_page: pageSize, sort_by: sort.field || "", sort_order: sort.order || "" })
						.then((response) => {
							setData(response.data);
							if (response.meta) {
								setTotalDataCount(response.meta.total);
								setCurrentPage(response.meta.current_page);
								setItemsPerPage(response.meta.per_page);
							}
						})
						.catch((err) => console.error("Error restoring filtered state:", err));
				} else {
					serviceDesk(selectedForm, page, pageSize, sort.field || "", sort.order || "");
				}
			}
		} catch {
			if (sdLocalKey) localStorage.removeItem(sdLocalKey);
		}
	}, [sdLocalKey, selectedForm]);
	// const handleSendQa = async (values) => {
	// 	try {
	// 		setLoading(true);
	// 		const response = await qaService.sendQaRequest(
	// 			selectedForm,
	// 			currentKey,
	// 			values.users
	// 		);
	// 		setLoading(false);
	// 		if (response.success) {
	// 			notification.success({
	// 				message: "Success",
	// 				description: response.message,
	// 			});
	// 		} else {
	// 			notification.error({
	// 				message: "Error",
	// 				description: response.message,
	// 			});
	// 		}
	// 		form.resetFields();
	// 		setIsSendQaModalVisible(false);
	// 	} catch (error) {
	// 		console.error("Error sending QA request:", error);
	// 		setLoading(false);
	// 		notification.error({
	// 			message: "Error",
	// 			description:
	// 				error.response.data.message ||
	// 				"There was an error sending the QA request.",
	// 		});
	// 	}
	// };

	const handleSendQa = async (entries) => {
		try {
			setLoading(true);

			// Prepare payload with singular 'user_id'
			const payload = entries.map((entry) => ({
				sequence_no: entry.sequence_no,
				// Ensure we get a single ID value, not an array
				user_id: Array.isArray(entry.users) ? entry.users[0] : entry.users,
			}));

			const response = await qaService.sendQaRequest(
				selectedForm,
				currentKey,
				payload
			);

			setLoading(false);

			if (response.success) {
				notification.success({
					message: "Success",
					description: response.message,
				});
			} else {
				notification.error({
					message: "Error",
					description: response.message,
				});
			}

			form.resetFields();
			setIsSendQaModalVisible(false);
		} catch (error) {
			console.error("Error sending QA request:", error);
			setLoading(false);
			notification.error({
				message: "Error",
				description:
					error.response?.data?.message ||
					"There was an error sending the QA request.",
			});
		}
	};

	const getLocations = async () => {
		const response = await locationService.getAllLocations();
		setLocations(response);
	};

	useEffect(() => {
		getLocations();
		getTaskStatus();
		getDepartments();
	}, []);

	// useEffect(() => {
	//   const savedForm = localStorage.getItem("selectedForm");
	//   if (savedForm) {
	//     setSelectedForm(JSON.parse(savedForm));
	//   } else {
	//     setSelectedForm(2);
	//   }
	// }, []);

	const handleDateChange = (date, dateString) => {
		setSelectedDate(dateString); // store formatted string like "25-04-2025"
	};
	const handleStartDateChange = (date, dateString) => {
		setSelectedStartDate(dateString); // store formatted string like "25-04-2025"
	};
	const handleEndDateChange = (date, dateString) => {
		setSelectedEndDate(dateString); // store formatted string like "25-04-2025"
	};

	// const onSearch = async (values) => {
	// 	if (selectedDate) {
	// 		const formattedDate = moment(selectedDate, "DD-MM-YYYY").isValid()
	// 			? moment(selectedDate, "DD-MM-YYYY").format("DD-MM-YYYY")
	// 			: null;
	// 		values.task_approval_at = formattedDate;
	// 	} else {
	// 		values.task_approval_at = null;
	// 	}
	// 	if (selectedStartDate) {
	// 		const formattedDate = moment(selectedStartDate, "DD-MM-YYYY").isValid()
	// 			? moment(selectedStartDate, "DD-MM-YYYY").format("DD-MM-YYYY")
	// 			: null;
	// 		values.start_at = formattedDate;
	// 	} else {
	// 		values.start_at = null;
	// 	}
	// 	if (selectedEndDate) {
	// 		const formattedDate = moment(selectedEndDate, "DD-MM-YYYY").isValid()
	// 			? moment(selectedEndDate, "DD-MM-YYYY").format("DD-MM-YYYY")
	// 			: null;
	// 		values.due_at = formattedDate;
	// 	} else {
	// 		values.due_at = null;
	// 	}

	// 	values.form_id = selectedForm;

	// 	// Handle multiple task_status values
	// 	if (Array.isArray(values.task_status)) {
	// 		// Remove 'empty' if other statuses are selected
	// 		if (
	// 			values.task_status.length > 1 &&
	// 			values.task_status.includes("empty")
	// 		) {
	// 			values.task_status = values.task_status.filter((v) => v !== "empty");
	// 		}
	// 		// If only 'empty' is selected, treat as 0
	// 		if (
	// 			values.task_status.length === 1 &&
	// 			values.task_status[0] === "empty"
	// 		) {
	// 			values.task_status = 0;
	// 		} else if (values.task_status.length > 0) {
	// 			// Join as comma-separated string for backend
	// 			values.task_status = values.task_status.join(",");
	// 		}
	// 	} else if (values.task_status === "empty") {
	// 		values.task_status = 0;
	// 	}

	// 	setSearchFilters(values);

	// 	console.log("values");
	// 	console.log(values);
	// 	console.log("values");
	// 	setLoading(true);
	// 	try {
	// 		const response = await formService.search(selectedForm, values);
	// 		setData(response.data);
	// 		setCurrentPage(response.meta.current_page);
	// 		setTotalDataCount(response.meta.total);
	// 		setItemsPerPage(response.meta.per_page);
	// 		setLoading(false);
	// 	} catch (error) {
	// 		setLoading(false);
	// 		console.error("Error while searching:", error);
	// 	}
	// };

	const handleClearFilters = () => {
		searchForm.resetFields();
		setSelectedDate(null);
		setSelectedStartDate(null);
		setSelectedEndDate(null);
		setSearchFilters({});
		setSortBy("");
		setSortOrder("");
		setCurrentPage(1);

		if (sdLocalKey) {
			localStorage.removeItem(sdLocalKey);
		}

		serviceDesk(selectedForm, 1, itemsPerPage, "", "");
	};

	const onSearch = async (values) => {
		// Handle dates
		if (selectedDate) {
			values.task_approval_at = moment(selectedDate, "DD-MM-YYYY").format(
				"DD-MM-YYYY"
			);
		} else values.task_approval_at = null;

		if (selectedStartDate) {
			values.start_at = moment(selectedStartDate, "DD-MM-YYYY").format(
				"DD-MM-YYYY"
			);
		} else values.start_at = null;

		if (selectedEndDate) {
			values.due_at = moment(selectedEndDate, "DD-MM-YYYY").format(
				"DD-MM-YYYY"
			);
		} else values.due_at = null;

		values.form_id = selectedForm;

		// Handle task_status
		if (!values.task_status || values.task_status.length === 0) {
			delete values.task_status;
		} else if (values.task_status.includes("empty")) {
			values.task_status = 0;
		} else {
			values.task_status = values.task_status.join(",");
		}

		// **Save to new localStorage logic**
		const sort = { field: sortBy, order: sortOrder };
		saveStateToLocal(values, 1, itemsPerPage, sort);

		setSearchFilters(values);
		setCurrentPage(1);
		setLoading(true);

		try {
			const response = await formService.search(selectedForm, { ...values, page: 1, per_page: itemsPerPage, sort_by: sortBy, sort_order: sortOrder });
			setData(response.data);
			setCurrentPage(response.meta.current_page);
			setTotalDataCount(response.meta.total);
			setItemsPerPage(response.meta.per_page);
			setLoading(false);
		} catch (error) {
			setLoading(false);
			console.error("Error while searching:", error);
		}
	};

	const handleSortChange = (pagination, filters, sorter) => {
		setSortOrder(sorter.order === "ascend" ? "asc" : "desc");
		setSortBy(sorter.field);

		serviceDesk(
			selectedForm,
			page,
			itemsPerPage,
			sorter.field,
			sorter.order === "ascend" ? "asc" : "desc"
		);
	};
	// const toggleFormVisibility = () => {
	//   setFormVisible(!formVisible);
	// };

	const onFinishUAT = (values) => {
		// console.log(currentKey, selectedForm);
	};

	useEffect(() => {
		if (formData?.assignedUsers?.length) {
			form.setFieldsValue({
				entries: formData.assignedUsers.map((item) => ({
					sequence_no: item.sequence_no,
					users: item.user_id, // <-- for UserComponent
					email_sent: item.email_sent,
				})),
			});
		}
	}, [formData, form]);

	const ActionsDropdown = ({ record }) => {
		//console.log(record)
		const handleMenuClick = async (info) => {
			const { key } = info;
			setCurrentKey(record.id);
			setCurrentLocation(record.location.name);
			switch (key) {
				case "1":
					break;
				case "2":
					openTaskModal(record);
					break;
				case "3": {
					const data = {
						form_id: selectedForm,
						key: record.id,
						status: record.comment_status === 0 ? 1 : 0,
					};
					handleComment(data);
					break;
				}
				// case "4": {
				// 	const QaData = {
				// 		form_id: selectedForm,
				// 		key: record.id,
				// 		users: "",
				// 	};
				// 	openSendQaRequest(QaData);
				// 	break;
				// }
				case "4": {
					const QaData = {
						form_id: selectedForm,
						key: record.id,
						users: "",
					};

					// API call only to get response
					const response = await qaService.getQaAssignments(
						selectedForm,
						record.id
					);
					console.log("QA Assignment Response:", response);

					QaData.assignedUsers = response.data; // store response in variable

					openSendQaRequest(QaData);
					break;
				}
				default:
					break;
			}
		};

		const handleComment = async (data) => {
			try {
				const response = await commentService.updateCommentStatus(data);
				if (response.success) {
					await serviceDesk(selectedForm, currentPage, itemsPerPage);
					notification.success({
						message: "Updated",
						description: response.message,
					});
				}
			} catch (error) {
				console.log(error);
				notification.error({
					message: "Error",
					description: error.response.data.message,
				});
			} finally {
				setLoading(false);
			}
		};
		const menu = {
			items: [
				{
					key: "1",
					icon: <EyeOutlined />,
					label: (
						<>
							{selectedForm === 2 && (
								<Link to={`/scrf/details/${record.id}`}>View</Link>
							)}
							{selectedForm === 3 && (
								<Link to={`/deployment/details/${record.id}`}>View</Link>
							)}
							{selectedForm === 4 && (
								<Link to={`/crf/details/${record.id}`}>View</Link>
							)}
							{selectedForm === 5 && (
								<Link to={`/mobile-requisition/details/${record.id}`}>
									View
								</Link>
							)}
							{selectedForm === 6 && (
								<Link to={`/master-data-management-form/details/${record.id}`}>
									View
								</Link>
							)}
							{selectedForm === 7 && (
								<Link to={`/sap-access-form/details/${record.id}`}>View</Link>
							)}
						</>
					),
				},
				...(record.task_assigned_at === null
					? [
							{
								key: "2",
								icon: <TeamOutlined />,
								label: "Assign Task",
							},
					  ]
					: []),
				{
					key: "3",
					icon: <CommentOutlined />,
					label: `Comment ${record.comment_status ? "Closed" : "Open"}`,
				},
				...(record.task_status?.name !== "Closed" &&
				record.task_status?.name !== "Rejected & Closed"
					? [
							{
								key: "4",
								icon: <TeamOutlined />,
								label: "Send QA Request",
							},
					  ]
					: []),
			],
			onClick: handleMenuClick,
		};

		return (
			<Dropdown menu={menu} trigger={["click"]}>
				<a className='ant-dropdown-link' onClick={(e) => e.preventDefault()}>
					<MenuOutlined />
				</a>
			</Dropdown>
		);
	};

	// const serviceDesk = async (form, page, itemsPerPage) => {
	//   try {
	//     setLoading(true);
	//     const response = await formService.serviceDesk(form, page, itemsPerPage);
	//     //console.log(response)
	//     setLoading(false);
	//     setData(response.data);
	//   } catch (error) {
	//     setLoading(false);
	//   }
	// };

	// const handleTableChange = (pagination, filters, sorter) => {
	//   // console.log('testttt ',pagination, filters, sorter);
	//   setSortOrder(sorter.order === "ascend" ? "asc" : "desc");
	//   setSortBy(sorter.field);

	//   serviceDesk(
	//     selectedForm,
	//     pagination.current,
	//     pagination.pageSize,
	//     sorter.field,
	//     sorter.order === "ascend" ? "asc" : "desc"
	//   );
	// };
	const filteredServiceDesk = async (
		form,
		page,
		itemsPerPage,
		sortBy,
		sortOrder,
		filters
	) => {
		try {
			setLoading(true);
			const response = await formService.search(form, {
				...filters,
				page,
				per_page: itemsPerPage,
				sort_by: sortBy,
				sort_order: sortOrder,
			});
			setData(response.data);
			setCurrentPage(response.meta.current_page);
			setTotalDataCount(response.meta.total);
			setItemsPerPage(response.meta.per_page);
		} catch (error) {
			console.error("Filtered search error:", error);
		} finally {
			setLoading(false);
		}
	};

	const handleTableChange = (pagination, filters, sorter) => {
		const newSortOrder = sorter.order === "ascend" ? "asc" : (sorter.order === "descend" ? "desc" : sortOrder);
		const newSortBy = sorter.field || sortBy;

		setSortOrder(newSortOrder);
		setSortBy(newSortBy);
		setCurrentPage(pagination.current); // Update the current page state
		setItemsPerPage(pagination.pageSize); // Update the items per page state

		// Save to localStorage logic
		const sort = { field: newSortBy, order: newSortOrder };

		// Handle task_status

		const values = searchForm.getFieldsValue();

				if (selectedDate) {
			values.task_approval_at = moment(selectedDate, "DD-MM-YYYY").format(
				"DD-MM-YYYY"
			);
		} else values.task_approval_at = null;

		if (selectedStartDate) {
			values.start_at = moment(selectedStartDate, "DD-MM-YYYY").format(
				"DD-MM-YYYY"
			);
		} else values.start_at = null;

		if (selectedEndDate) {
			values.due_at = moment(selectedEndDate, "DD-MM-YYYY").format(
				"DD-MM-YYYY"
			);
		} else values.due_at = null;

		values.form_id = selectedForm;

		if (!values.task_status || values.task_status.length === 0) {
		delete values.task_status;
		} else if (values.task_status.includes("empty")) {
		values.task_status = 0;
		} else {
		values.task_status = values.task_status.join(",");
		}
		console.log('handleTableChange by:', values);

		saveStateToLocal(values, pagination.current, pagination.pageSize, sort);

		// If filters exist, use filtered service
		if (Object.keys(searchFilters).length > 0) {
			filteredServiceDesk(
				selectedForm,
				pagination.current,
				pagination.pageSize,
				newSortBy,
				newSortOrder,
				searchFilters
			);
		} else {
			serviceDesk(
				selectedForm,
				pagination.current,
				pagination.pageSize,
				newSortBy,
				newSortOrder
			);
		}
	};

	const handleFormChange = (selectedValue) => {
		setSelectedForm(selectedValue);
		localStorage.setItem("selectedForm", selectedValue);
		console.log(selectedValue);
	};

	const serviceDesk = async (
		form,
		page = 1,
		itemsPerPage = 10,
		sortBy = "",
		sortOrder = ""
	) => {
		try {
			setLoading(true);
			const response = await formService.serviceDesk(
				form,
				page,
				itemsPerPage,
				sortBy,
				sortOrder
			);
			setLoading(false);
			setData(response.data);
			setCurrentPage(response.meta.current_page);
			setTotalDataCount(response.meta.total);
			setItemsPerPage(response.meta.per_page);
			return response;
		} catch (error) {
			setLoading(false);
			console.error("Error fetching data:", error);
			// Handle error, display message to the user
			notification.error({
				message: "Error",
				description: "There was a problem fetching data from the server.",
			});
		}
	};

	useEffect(() => {
		const fetchData = async () => {
			let savedForm = localStorage.getItem("selectedForm");
			try {
				savedForm = savedForm ? JSON.parse(savedForm) : selectedForm;
			} catch (error) {
				console.error("Error parsing savedForm:", error);
				savedForm = selectedForm;
			}

			if (!savedForm) {
				console.warn("No form_id selected. Defaulting to form_id 2.");
				savedForm = 2;
				localStorage.setItem("selectedForm", 2);
			}

			setSelectedForm(savedForm);

			// Only fetch fresh data if no saved state was restored for this user
			if (sdLocalKey && localStorage.getItem(sdLocalKey)) return;

			try {
				setLoading(true);
				const res = await serviceDesk(savedForm);
				// setData(res.data);
				setLoading(false);
			} catch (error) {
				console.error("Error fetching data:", error);
				setLoading(false);
			}
		};

		fetchData();
	}, [sdLocalKey]);

	const columns = [
		{
			title: "ID",
			dataIndex: "id",
			key: "id",
			fixed: useMediaQuery({ minWidth: 768 }) ? "left" : null,
			width: 40,
		},
		{
			title: "Sequence No",
			dataIndex: "sequence_no",
			key: "sequence_no",
			width: 120,
			fixed: useMediaQuery({ minWidth: 768 }) ? "left" : null,
			sorter: true,
		},
		{
			title: "Request Title",
			dataIndex: "request_title",
			key: "request_title",
			// width: 160,
			fixed: useMediaQuery({ minWidth: 768 }) ? "left" : null,
			sorter: true,
		},
		// {
		//   title: 'Software Category',
		//   dataIndex: ['software_category', 'name'],
		//   key: 'software_category',
		//   width: 170,
		//   sorter: true,
		// },
		// {
		//   title: 'Subcategory',
		//   dataIndex: ['software_subcategories', 'name'],
		//   key: 'software_subcategories',
		//   width: 170,
		//   sorter: true,
		//   render: (text, record) => record.software_subcategories.map((subcategory) => subcategory.name).join(', '),
		// },
		{
			title: "Location",
			dataIndex: ["location", "name"],
			key: "location",
			// width: 120,
			sorter: true,
		},
		{
			title: "Department",
			dataIndex: ["department", "name"],
			key: "department",
			// width: 120,
			sorter: true,
		},
		{
			title: "Task Initiated At",
			dataIndex: "task_initiated_at",
			key: "task_initiated_at",
			// width: 200,
			sorter: true,
		},
		{
			title: "Task Assigned At",
			dataIndex: "task_assigned_at",
			key: "task_assigned_at",
			// width: 200,
			sorter: true,
			// sorter: (a, b) => {
			//   const dateA = moment(a.task_assigned_at);
			//   const dateB = moment(b.task_assigned_at);
			//   return dateA - dateB;
			// },
		},
		{
			title: "Task Approval At",
			dataIndex: "task_approval_at",
			key: "task_approval_at",
			// width: 180,
			// sorter: (a, b) => {
			//   const dateA = new Date(a.task_approval_at);
			//   const dateB = new Date(b.task_approval_at);
			//   return dateA - dateB;
			// },
		},
		{
			title: "Start Date",
			dataIndex: ["task_assigned", "expected_start_time"],
			key: "task_assigned",
			// width: 200,
			sorter: true,
		},
		{
			title: "End Date",
			dataIndex: ["task_assigned", "expected_end_time"],
			key: "task_assigned",
			// width: 200,
			sorter: true,
		},
		{
			title: "Task Status",
			dataIndex: ["task_status", "name"],
			key: "task_status",
			// width: 180,
			sorter: true,
			// sorter: (a, b) => a.task_status.name.localeCompare(b.task_status.name),
		},
		{
			title: "Approval Status",
			dataIndex: "status",
			key: "status",
			// width: 180,
			// sorter: (a, b) => a.status.localeCompare(b.status),
		},
		{
			title: "Task Assigned Teams",
			dataIndex: "task_assigned_teams",
			key: "task_assigned_teams",
			width: 400,
			render: (teams) => {
				if (!teams || teams.length === 0) return "";

				const collapseItems = teams.map((team, index) => ({
					key: index,
					label: team.team.name,
					children: (
						<div>
							<div>
								<strong>Managers:</strong>{" "}
								{team.managers.map((m) => m.name).join(", ")}
							</div>
							<div>
								<strong>Members:</strong>{" "}
								{team.members.map((m) => m.name).join(", ")}
							</div>
							<div>
								<strong>Start:</strong> {team.start_at || "N/A"}{" "}
								&nbsp;&nbsp;-&nbsp;&nbsp;
								<strong>End:</strong> {team.due_at || "N/A"}
							</div>
						</div>
					),
					style: { background: "#FFFBFB" },
				}));

				return (
					<Collapse
						accordion
						items={collapseItems}
						style={{
							border: "none",
							boxShadow: "0px 1px 5px 1px rgb(0 0 0 / 10%)",
							background: "fff",
						}}
					/>
				);
			},
			sorter: (a, b) => {
				const teamsA = (a.task_assigned_teams || [])
					.map((team) => team.team.name)
					.join(", ");
				const teamsB = (b.task_assigned_teams || [])
					.map((team) => team.team.name)
					.join(", ");
				return teamsA.localeCompare(teamsB);
			},
		},
		{
			title: "Actions",
			key: "actions",
			width: 80,
			fixed: useMediaQuery({ minWidth: 768 }) ? "right" : null,
			render: (text, record) => <ActionsDropdown record={record} />,
		},
	];

	const handleClick = async () => {
		setIsExporting(true);
		// 1. Define the columns for the Excel file, ensuring dataIndex is a simple string.
		const excelColumns = columns
			.filter((col) => col.key !== "actions") // Exclude the 'Actions' column
			.map((col) => ({
				title: col.title,
				dataIndex: Array.isArray(col.dataIndex)
					? col.dataIndex.join("_")
					: col.dataIndex,
				key: col.key,
			}));

		// 2. Fetch all the data that needs to be exported.
		// This logic ensures that if filters are applied, all filtered results are exported, not just the current page.
		setLoading(true);
		let allData;
		try {
			const filters = searchFilters;
			let response;
			if (Object.keys(filters).length > 0) {
				response = await formService.search(selectedForm, {
					...filters,
					page: 1,
					perPage: totalDataCount > 0 ? totalDataCount : 1000,
				});
			} else {
				response = await formService.serviceDesk(
					selectedForm,
					1,
					totalDataCount > 0 ? totalDataCount : 1000
				);
			}
			allData = response.data;
		} catch (error) {
			console.error("Error fetching data for export:", error);
			notification.error({
				message: "Export Failed",
				description: "Could not fetch all the data for the export.",
			});
			setLoading(false);
			setIsExporting(false);
			return;
		}
		setLoading(false);

		// 3. Manually process the data to create a readable string for complex fields.
		const processedData = allData.map((record) => {
			// Create a new object to avoid mutating the original state
			const newRecord = { ...record };

			// Flatten nested data for other columns
			newRecord.location_name = record.location?.name;
			newRecord.department_name = record.department?.name;
			newRecord.task_status_name = record.task_status?.name;
			newRecord.task_assigned_expected_start_time =
				record.task_assigned?.expected_start_time;
			newRecord.task_assigned_expected_end_time =
				record.task_assigned?.expected_end_time;

			// Specifically format the 'Task Assigned Teams' data into a string
			if (record.task_assigned_teams && record.task_assigned_teams.length > 0) {
				newRecord.task_assigned_teams = record.task_assigned_teams
					.map((teamInfo) => {
						const teamName = teamInfo.team?.name || "N/A";
						const managers =
							teamInfo.managers?.map((m) => m.name).join(", ") || "None";
						const members =
							teamInfo.members?.map((m) => m.name).join(", ") || "None";
						return `${teamName} (Managers: ${managers}; Members: ${members})`;
					})
					.join(" | "); // Join multiple teams with a separator
			} else {
				newRecord.task_assigned_teams = "Not Assigned";
			}
			return newRecord;
		});

		// 4. Update the columns definition for the export to match the new processed data keys
		const finalExcelColumns = [
			{ title: "ID", dataIndex: "id" },
			{ title: "Sequence No", dataIndex: "sequence_no" },
			{ title: "Request Title", dataIndex: "request_title" },
			{ title: "Location", dataIndex: "location_name" },
			{ title: "Department", dataIndex: "department_name" },
			{ title: "Task Initiated At", dataIndex: "task_initiated_at" },
			{ title: "Task Assigned At", dataIndex: "task_assigned_at" },
			{ title: "Task Approval At", dataIndex: "task_approval_at" },
			{ title: "Start Date", dataIndex: "task_assigned_expected_start_time" },
			{ title: "End Date", dataIndex: "task_assigned_expected_end_time" },
			{ title: "Task Status", dataIndex: "task_status_name" },
			{ title: "Approval Status", dataIndex: "status" },
			{ title: "Task Assigned Teams", dataIndex: "task_assigned_teams" }, // This now points to our formatted string
		];

		// 5. Create and save the Excel file
		const excel = new Excel();
		excel
			.addSheet("Service Desk Data")
			.addColumns(finalExcelColumns)
			.addDataSource(processedData, { str2Percent: true })
			.saveAs("ServiceDesk.xlsx");
			
		setIsExporting(false);
	};

	const openUATModal = () => {
		setIsUATModalVisible(true);
	};

	const closeUATModal = () => {
		setIsUATModalVisible(false);
	};

	const openTaskModal = (record) => {
		form.resetFields();
		setFormData(record);
		setTaskId(record.id);
		setIsTaskModalVisible(true);

		const hasMembers =
			Array.isArray(record.task_assigned_teams) &&
			record.task_assigned_teams.some(
				(team) =>
					team.members && Array.isArray(team.members) && team.members.length > 0
			);
		setEdit(hasMembers);
	};

	const closeTaskModal = async () => {
		setIsTaskModalVisible(false);
		if (selectedForm !== null) {
			await serviceDesk(selectedForm, page, itemsPerPage);
		}
	};

	const openSendQaRequest = (record) => {
		setFormData(record);
		setTaskId(record.id);
		setIsSendQaModalVisible(true);

		const hasMembers =
			Array.isArray(record.task_assigned_teams) &&
			record.task_assigned_teams.some(
				(team) =>
					team.members && Array.isArray(team.members) && team.members.length > 0
			);
		setEdit(hasMembers);

		if (record.assignedUsers) {
			form.setFieldsValue({
				entries: record.assignedUsers.map((item) => ({
					sequence_no: item.sequence_no,
					users: item.user_id,
					email_sent: item.email_sent,
					feedback: item.feedback,
				})),
			});
		}
	};

	const closeSendQaModal = async () => {
		form.resetFields();
		setIsSendQaModalVisible(false);
		if (selectedForm !== null) {
			await serviceDesk(selectedForm, page, itemsPerPage);
		}
	};

	const [visibleColumns, setVisibleColumns] = useState(() =>
		columns.map((column) => column.key)
	);
	const handleColumnToggle = (key) => {
		const updatedVisibleColumns = [...visibleColumns];

		if (visibleColumns.includes(key)) {
			const index = updatedVisibleColumns.indexOf(key);
			if (index > -1) {
				updatedVisibleColumns.splice(index, 1);
			}
		} else {
			updatedVisibleColumns.push(key);
		}

		setVisibleColumns(updatedVisibleColumns);

		try {
			localStorage.setItem(
				"visibleColumnsServiceDesk",
				JSON.stringify(updatedVisibleColumns)
			);
		} catch (error) {
			console.error("Error saving visibleColumns to local storage:", error);
		}
	};

	useEffect(() => {
		try {
			const savedVisibleColumns = localStorage.getItem(
				"visibleColumnsServiceDesk"
			);
			if (savedVisibleColumns) {
				setVisibleColumns(JSON.parse(savedVisibleColumns));
			}
		} catch (error) {
			console.error("Error loading visibleColumns from local storage:", error);
		}
	}, []);
	const menuConfig = {
		items: columns.map((column) => ({
			key: column.key,
			label: (
				<Checkbox
					className='mr-5'
					style={{ fontSize: "12px" }}
					onChange={() => handleColumnToggle(column.key)}
					checked={visibleColumns.includes(column.key)}
				>
					{column.title}
				</Checkbox>
			),
		})),
	};

	return (
		<DefaultLayout>
			<Row gutter={[24, 24]}>
				<Col span={24}>
					<Header
						icon={<TeamOutlined />}
						title='Service Desk'
						right={
							<>
								<Button loading={isExporting} disabled={isExporting} onClick={handleClick} className='mt-10 mb-10 mr-10'>
									Export
								</Button>
							</>
						}
					/>
				</Col>
			</Row>

			{!loading && (
				<Card>
					<FormListComponent
						onChange={handleFormChange}
						selectedFormId={selectedForm}
					/>
				</Card>
			)}
			<Row gutter={[24, 24]}>
				<Col span={24}>
					<Card>
						<Form form={searchForm} onFinish={onSearch} layout='vertical'>
							<Card className='pt-6' style={{ paddingBottom: "0 !important" }}>
								<Row gutter={[12, 12]}>
									<Col lg={4} md={5} sm={6} xs={12}>
										<Form.Item name='sequence_no'>
											<Input size='large' placeholder='Sequence No' />
										</Form.Item>
									</Col>

									<Col lg={7} md={8} sm={9} xs={12}>
										<Form.Item name='request_title'>
											<Input size='large' placeholder='Request Title' />
										</Form.Item>
									</Col>

									<Col lg={4} md={5} sm={6} xs={12}>
										<Form.Item name={["department_id"]}>
											<Select
												showSearch={true}
												optionFilterProp='children'
												style={{ width: "100%" }}
												size='large'
												placeholder='Please Select Department'
												allowClear
											>
												{departments &&
													departments.map((department) => (
														<Select.Option
															key={department.id}
															value={department.id}
														>
															{department.name}
														</Select.Option>
													))}
											</Select>
										</Form.Item>
									</Col>
									<Col lg={4} md={5} sm={6} xs={12}>
										<Form.Item name={["location_id"]}>
											<Select
												showSearch={true}
												optionFilterProp='children'
												style={{ width: "100%" }}
												size='large'
												placeholder='Please Select Location'
												allowClear
											>
												{locations &&
													locations.map((loc) => (
														<Select.Option key={loc.id} value={loc.id}>
															{loc.name}
														</Select.Option>
													))}
											</Select>
										</Form.Item>
									</Col>
									<Col lg={4} md={5} sm={6} xs={12}>
										<Form.Item name='task_status'>
											<Select
												mode='multiple'
												showSearch={true}
												optionFilterProp='children'
												style={{ width: "100%" }}
												size='large'
												placeholder='Please Select Task Status'
												allowClear
												maxTagCount={2}
												onChange={(values) => {
													if (values.includes("empty") && values.length > 1) {
														searchForm.setFieldValue("task_status", ["empty"]);
													}
												}}
											>
												<Select.Option key='no-status' value={"empty"}>
													No Status
												</Select.Option>
												{taskStatus &&
													taskStatus.map((task) => (
														<Select.Option key={task.id} value={task.id}>
															{task.name}
														</Select.Option>
													))}
											</Select>
										</Form.Item>
									</Col>

									<Col lg={4} md={5} sm={6} xs={12}>
										<Form.Item
											name='manager_ids'
											label='Select Assigned Managers'
										>
											<UserComponent mode='multiple' />
										</Form.Item>
									</Col>

									<Col lg={4} md={5} sm={6} xs={12}>
										<Form.Item
											name='member_ids'
											label='Select Assigned Members'
										>
											<UserComponent mode='multiple' />
										</Form.Item>
									</Col>

									<Col lg={4} md={5} sm={6} xs={12}>
										<Form.Item
											label='Task Approved At'
											name='task_approval_at'
											valuePropName='value'
										>
											<DatePicker
												format={dateFormat}
												onChange={handleDateChange}
												style={{ width: "100%" }}
												size='large'
											/>
										</Form.Item>
									</Col>
									<Col lg={4} md={5} sm={6} xs={12}>
										<Form.Item
											label='Start At'
											name='start_at'
											valuePropName='value'
										>
											<DatePicker
												format={dateFormat}
												onChange={handleStartDateChange}
												style={{ width: "100%" }}
												size='large'
											/>
										</Form.Item>
									</Col>
									<Col lg={4} md={5} sm={6} xs={12}>
										<Form.Item
											label='Due At'
											name='due_at'
											valuePropName='value'
										>
											<DatePicker
												format={dateFormat}
												onChange={handleEndDateChange}
												style={{ width: "100%" }}
												size='large'
											/>
										</Form.Item>
									</Col>

									<Col lg={4} md={5} sm={6} xs={12}>
										<Form.Item
											name='end_last_days'
											label='Expected Last End Days'
										>
											<Select size='large' placeholder='Select Days' allowClear>
												<Select.Option value={7}>7</Select.Option>
												<Select.Option value={15}>15</Select.Option>
												<Select.Option value={30}>30</Select.Option>
											</Select>
										</Form.Item>
									</Col>

									<Col
										lg={4}
										md={5}
										sm={6}
										xs={12}
										className='d-flex align-items-center'
									>
										<p>&nbsp;</p>
										<div style={{ display: "flex", gap: "10px" }}>
											<Button
												block
												className='btn-blue'
												htmlType='submit'
												type='primary'
												size='large'
											>
												Search
											</Button>
											<Button
												block
												size='large'
												onClick={handleClearFilters}
											>
												Clear
											</Button>
										</div>
									</Col>
								</Row>
							</Card>
						</Form>
					</Card>
				</Col>
			</Row>
			<Row gutter={[24, 24]}>
				<Col span={24}>
					<Card>
						{data.length > 0 ? (
							<div>
								<Dropdown
									className='mr-10'
									menu={menuConfig}
									open={visible}
									onOpenChange={(isVisible) => setVisible(isVisible)}
									trigger={["click"]}
								>
									<button // Replaced <a> with <button>
										style={{
											color: "black",
											fontSize: "11px",
											color: "gray",
											background: "transparent", // Make button background transparent
											border: "none", // Remove button border
											padding: 0, // Remove default button padding
											cursor: "pointer", // Set cursor to pointer
										}}
										onClick={(e) => e.preventDefault()}
									>
										<UnorderedListOutlined /> Columns
									</button>
								</Dropdown>

								<Table
									rowKey='id'
									style={{ minHeight: "100vh" }}
									virtual
									scroll={{ x: 2000, y: 1000 }}
									sticky={true}
									columns={columns.filter((column) =>
										visibleColumns.includes(column.key)
									)}
									// columns={columns}
									onChange={handleTableChange}
									dataSource={data}
									// pagination={true}
									pagination={{
										showSizeChanger: true,
										pageSizeOptions: ["10", "15", "25", "50", "100"],
										current: currentPage,
										total: totalDataCount,
										pageSize: itemsPerPage,
									}}
									loading={loading}
									rowClassName={(record) => {
										return record.task_assigned_at !== null
											? "task-assigned-row"
											: "";
									}}
								/>
							</div>
						) : (
							<Empty description='No record found.' />
						)}
					</Card>
				</Col>
			</Row>
			<>
				<Modal
					title='UAT/Feedback Request'
					open={isUATModalVisible}
					onCancel={closeUATModal}
					footer={null}
				>
					<Form layout='vertical' onFinish={onFinishUAT}>
						<Form.Item
							name='name'
							label='Title'
							rules={[{ required: true, message: "Please enter title" }]}
						>
							<Input size='large' />
						</Form.Item>

						<Form.Item
							name='user_id'
							label='User'
							rules={[{ required: true, message: "Please select user" }]}
						>
							<UserComponent />
						</Form.Item>

						<Form.Item>
							<Button type='primary' htmlType='submit'>
								Submit
							</Button>
						</Form.Item>
					</Form>
				</Modal>

				<Modal
					title='Assign Task To Team/Members'
					open={isTaskModalVisible}
					onCancel={closeTaskModal}
					footer={null}
					size='xl'
				>
					<TaskDetailsComponent
						selectedForm={selectedForm}
						taskId={taskId}
						onTaskFinished={closeTaskModal}
						editData={edit}
						formData={formData}
					/>
				</Modal>

				<Modal
					title='Send QA Request'
					open={isSendQaModalVisible}
					onCancel={closeSendQaModal}
					footer={null}
					width='60%'
					styles={{ body: { maxHeight: "70vh", overflowY: "auto" } }}
				>
					<Form form={form} onFinish={(values) => handleSendQa(values.entries)}>
						<Form.List name='entries'>
							{(fields, { add, remove }) => (
								<>
									{fields.map(({ key, name, ...restField }, index) => {

										const emailSent = form.getFieldValue([
											"entries",
											name,
											"email_sent",
										]);

										const feedback = form.getFieldValue([
											"entries",
											name,
											"feedback",
										]);

										const isLocked = emailSent || feedback; // 🔥 main condition

										// get all selected users except current row
										const selectedUsersInOtherRows =
											form
												.getFieldValue("entries")
												?.filter((_, i) => i !== index)
												.map((e) => e.users)
												.filter(Boolean) || [];

										return (
											<Row gutter={[12, 12]} key={key} align='middle'>
												<Col xs={24} sm={4}>
													<Form.Item
														{...restField}
														name={[name, "sequence_no"]}
														rules={[
															{
																required: true,
																message: "Missing sequence no",
															},
														]}
													>
														<Input readOnly />
													</Form.Item>
												</Col>

												<Col xs={24} sm={18}>
													<Form.Item
														{...restField}
														name={[name, "users"]}
														rules={[
															{ required: true, message: "Select user(s)" },
														]}
													>
														<UserComponent
															multiselect={false}
															selectedUsers={restField.value} // current value
															excludedUsers={selectedUsersInOtherRows} // pass to filter
															// disabled={isLocked} // 👈 disable select

														/>
													</Form.Item>
												</Col>

												<Col xs={24} sm={2}>
													<Form.Item noStyle shouldUpdate>
														{() => {
															const emailSent = form.getFieldValue([
																"entries",
																index,
																"email_sent",
															]);
															const isDisabled = emailSent === false;
															return (
																<Button
																	type='link'
																	danger
																	// disabled={isDisabled}
																	// disabled={isLocked} // ✅ restrict when locked
																	onClick={() => remove(name)}
																>
																	Remove
																</Button>
															);
														}}
													</Form.Item>
												</Col>
											</Row>
										);
									})}
									<Form.Item>
										<Button
											type='dashed'
											onClick={() => add({ sequence_no: fields.length + 1 })}
											block
										>
											+ Add More
										</Button>
									</Form.Item>
								</>
							)}
						</Form.List>

						<Form.Item>
							<Button type='primary' htmlType='submit' loading={loading} block>
								Send Request
							</Button>
						</Form.Item>
					</Form>
				</Modal>
			</>
		</DefaultLayout>
	);
};

export default ServiceDesk;
